import { TableFilter } from "@neonumy/ant-design";
import { useGetWindowHeight } from "@neonumy/neonumy-ui";
import { Button, Card, Row } from "antd";
import CardTitle from "components/CardTitle";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowRight } from "react-icons/fa";
import { FaBarcode } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import CreateUpdateClientVatTypes from "./components/CreateUpdateClientVatTypes";
import useClientVatTypesApi from "./hooks/useClientVatTypesApi";
import useTableColumns from "./hooks/useTableColumns";

interface ClientVatTypesPropsTypes {
  nextButton?: () => void;
  prevButton?: () => void;
}
export default function ClientVatTypes(props: ClientVatTypesPropsTypes): React.ReactElement {
  const windowHeight = useGetWindowHeight();
  const paginationInit = {
    offset: 0,
    limit: 10,
  };
  const { nextButton } = props;
  const { t } = useTranslation();
  const urlParams: RouteParams = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const {
    refetchListClientVatTypes: refetch,
    loadingListClientVatTypes: loading,
    clientVatTypesTotalCount: totalCount,
    clientsVatTypesData: dataSource,
    listClientVatTypes,
  } = useClientVatTypesApi();

  const COLUMNS = useTableColumns(refetch);

  useEffect(() => {
    if (urlParams.companyId) {
      listClientVatTypes({
        variables: {
          filter: {
            companyId: urlParams.companyId,
          },
          ...paginationInit,
        },
      });
    }
  }, [urlParams.companyId]);

  const handlePagination = (page: number, size: number) => {
    setPageSize(size);
    setCurrentPage(page);
    refetch({
      limit: size,
      offset: size * (page - 1),
    });
  };

  return (
    <>
      <Card
        title={<CardTitle icon={<FaBarcode />} title={t("Client vat type")} />}
        className="antd-newrai-card"
      >
        <TableFilter
          className="antd-newrai-table"
          size="small"
          scroll={{ y: windowHeight - 550 }}
          dataSource={dataSource}
          loading={loading}
          columns={COLUMNS}
          pagination={{
            onChange: handlePagination,
            showSizeChanger: true,
            current: currentPage,
            pageSize: pageSize,
            total: totalCount,
            showTotal: total => t("Total table items", { count: total }),
          }}
          debounced={true}
        />
        <CreateUpdateClientVatTypes refetch={refetch} />
      </Card>

      {nextButton && (
        <Row justify="end">
          <Button
            type="primary"
            className="save-btn"
            onClick={() => nextButton()}
            icon={<FaArrowRight />}
          >
            {t("Next")}
          </Button>
        </Row>
      )}
    </>
  );
}
